module.exports = __webpack_public_path__ + "img/7.b775d138.png";